import React from 'react';
import '../styles/HowToPlay.css';

function HowToPlay({ onBack, onLeaderboard }) {

  return (
    <div className="how-to-play">
      <div className="how-container">
        <div className="how-brand">
          <div className="how-brand-badge">B</div>
          <h2>How to Play BuildPro</h2>
        </div>
        <p className="how-intro">Start with 6 letters, build connected words, and keep clearing your hand before the next drop lands.</p>

        <div className="rules-section">
          <h3>Game Loop</h3>
          <ul>
            <li>There are 20 active letters in the base game that eventually need to be placed.</li>
            <li>You start with 6 letters in your hand.</li>
            <li>When you place those letters into a valid connected board, the next 2 letters drop into your hand.</li>
            <li>You get 30 seconds before the next automatic drop if you have not already cleared the hand.</li>
            <li>If you clear your hand with a valid connected board before the timer ends, the next 2 letters arrive immediately.</li>
            <li>The game ends when all required letters are placed, the queue is empty, your hand is empty, and the board validates.</li>
            <li>Exchanges can increase the number of letters you end up placing, because you trade 1 letter back for 2 new ones.</li>
            <li>2-letter words are allowed if they are in the approved two-letter word list.</li>
            <li>Longer words must exist in the dictionary.</li>
          </ul>
        </div>

        <div className="rules-section">
          <h3>Features</h3>
          <ul>
            <li><strong>Drag and drop:</strong> Move a letter from your hand onto the board, or move a placed tile to a new cell.</li>
            <li><strong>Tap to place:</strong> Select a hand tile, then tap a cell to place it.</li>
            <li><strong>Undo Last:</strong> Revert your last tile placement.</li>
            <li><strong>Clear Board:</strong> Remove all tiles and start over.</li>
            <li><strong>Queue drop:</strong> New letters enter your hand in groups of 2 from the queue.</li>
            <li><strong>Fast drop:</strong> Valid connected boards can trigger the next hand early when you clear the current hand.</li>
            <li><strong>Exchange:</strong> Trade one hand letter back into the bank and receive 2 replacement letters, as long as the bank has at least 2 letters available.</li>
            <li><strong>Leaderboard:</strong> Compare your completion time with everyone else on regular days, or your points on Points Friday.</li>
          </ul>
        </div>

        <div className="rules-section">
          <h3>Validation</h3>
          <ul>
            <li>Green borders = valid word in dictionary</li>
            <li>Red borders = word too short or not in dictionary</li>
            <li>Yellow borders = word is valid but disconnected from main grid</li>
          </ul>
        </div>

        <div className="rules-section">
          <h3>Scoring</h3>
          <p>Regular days rank by completion time. On Points Friday, start with all 24 tiles and no swapping. The goal is to score points: 2–4 letter words score 1 point, 5 letters score 2, 6 score 3, 7 score 5, and 8+ score 11.</p>
        </div>

        <div className="how-footer">
          <button onClick={onBack} className="btn btn-primary">
            Play Now
          </button>
          <button onClick={onLeaderboard} className="btn btn-secondary">
            View Leaderboard
          </button>
        </div>
      </div>
    </div>
  );
}

export default HowToPlay;
